import BaseService from '_services/rest/base';

class PdfService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/pdf`;
  }

  extract(params) {
    const formData = new FormData();
    formData.append('pdf_file', params.file);
    formData.append('template', params.template);
    return this.request(`${this.getUrl()}/extract`, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  importMapped(file, templateKey) {
    const formData = new FormData();
    formData.append('pdf_file', file);
    formData.append('template', templateKey);
    return this.request(`${this.getUrl()}/import`, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => { throw err; });
  }
}

export default new PdfService();
